var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map"},[_c('GmapMap',{ref:"googleMap",staticClass:"map",attrs:{"zoom":_vm.zoom,"center":_vm.center,"options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }